import { useEffect, useRef, useState } from 'react'

const useDropdown = () => {
    const [open, setOpen] = useState(false)
    const ref = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    const toggle = () => setOpen((current) => !current)
    const close = () => setOpen(false)

    return { open, toggle, close, ref }
}

export default useDropdown
